import { FieldTypes } from '../../../constants/FieldTypes'
import { DropdownField, Field, FieldMap, InfoStage } from '../../../types/forms/fields'
import { selectCoverageOption } from './utils'

export const coverageWillChangeDescriptionField: DropdownField = {
  condition: selectCoverageOption('coverage-will-change'),
  type: FieldTypes.DROPDOWN,
  labels: [{ text: 'Please choose one:' }],
  placeholder: 'Coverage will change description',
  options: [
    {
      text: 'My employment will change/My employer is choosing another health plan that I have/can get information on.',
      id: 'employment-coverage-will-change',
      redFlagReason: 'Coverage will change during pregnancy',
    },
    {
      text: "My employment will change/My employer is choosing another health plan but I don't know the options.",
      id: 'employment-coverage-will-change-unknown',
      redFlagReason: 'Coverage will change during pregnancy',
    },
    {
      text: 'My coverage will drop before I deliver',
      id: 'coverage-will-drop',
      redFlagReason: 'Coverage will drop during pregnancy',
    },
    {
      text: 'I will be added to another plan before I deliver',
      id: 'added-to-another-plan',
      redFlagReason: 'Coverage will change during pregnancy',
    },
  ],
}

const employmentWillChangeNote: InfoStage = {
  info: true,
  name: 'Notice',
  condition: v =>
    selectCoverageOption('coverage-will-change')(v) &&
    v?.coverageWillChangeDescription === 'employment-coverage-will-change',
  data: [
    {
      type: 'span',
      children: [
        {
          text: `Please use information on your future plan to complete this form so we can provide an assessment.\n 
You may need to contact HR in order to get all the necessary information.`,
        },
      ],
    },
  ],
}

const employmentWillChangeUnknownNote: InfoStage = {
  info: true,
  name: 'Notice',
  condition: v =>
    selectCoverageOption('coverage-will-change')(v) &&
    v?.coverageWillChangeDescription === 'employment-coverage-will-change-unknown',
  data: [
    {
      type: 'span',
      children: [
        {
          text: 'We cannot provide an assessment until you have information on your future insurance plan. Please return to this website when you do, or provide us with information you do have at this time so we can try to assist further below. If you do have information on your future, select "I am covered by one insurance plan" on the first dropdown above.\nYou can also schedule a call with us if you have further questions - Help Button (?) or Contact Page',
        },
      ],
    },
  ],
}

const coverageWillDropNote: InfoStage = {
  info: true,
  name: 'Notice',
  condition: v =>
    selectCoverageOption('coverage-will-change')(v) &&
    v?.coverageWillChangeDescription === 'coverage-will-drop',
  data: [
    {
      type: 'span',
      children: [
        {
          text: 'If you believe your coverage will end before you deliver, press finish to see options for choosing a plan through New York State of Health.\nYou can also schedule a call with us if you have further questions - Help Button (?) or Contact Page',
        },
      ],
    },
  ],
}

const addedToAnotherPlanNote: InfoStage = {
  info: true,
  name: 'Notice',
  condition: v =>
    selectCoverageOption('coverage-will-change')(v) &&
    v?.coverageWillChangeDescription === 'added-to-another-plan',
  data: [
    {
      type: 'span',
      children: [
        {
          text: 'Please use information on your future plan to complete this form so we can provide an assessment',
        },
      ],
    },
  ],
}

// const newCoverageStartDateField: DateField = {
//   condition: v =>
//     selectCoverageOption('coverage-will-change')(v) &&
//     v?.coverageWillChangeDescription?.startsWith('employment-coverage-will-change'),
//   type: FieldTypes.DATE,
//   placeholder: 'New coverage start date',
//   labels: [{ text: 'When will your new coverage begin?' }],
//   minDate: 'now',
// }

export const coverageWillChangeDetailsFields: Record<string, Field | InfoStage> = {
  // newCoverageStartDate: newCoverageStartDateField,
  employmentWillChangeNote,
  employmentWillChangeUnknownNote,
  coverageWillDropNote,
  addedToAnotherPlanNote,
}

export const coverageWillChangeFields: Record<string, Field | InfoStage> = {
  coverageWillChangeDescription: coverageWillChangeDescriptionField,
  ...coverageWillChangeDetailsFields,
}

export const coverageWillChangeField: FieldMap = {
  name: 'Please specify',
  children: coverageWillChangeFields,
}

export const coverageWillChangeDetailsField: FieldMap = {
  name: 'Coverage will change - details',
  children: coverageWillChangeDetailsFields,
}
